! function (e, t) {
    "object" == typeof exports && "undefined" != typeof module ? t(exports, require("jquery"), require("popper.js")) : "function" == typeof define && define.amd ? define(["exports", "jquery", "popper.js"], t) : (e = "undefined" != typeof globalThis ? globalThis : e || self, t(e.bootstrap = {}, e.jQuery, e.Popper))
}(this, function (e, t, n) {
    "use strict";

    function i(e, t) {
        for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
        }
    }

    function o(e, t, n) {
        return t && i(e.prototype, t), n && i(e, n), e
    }

    function s() {
        return s = Object.assign || function (e) {
            for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];
                for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i])
            }
            return e
        }, s.apply(this, arguments)
    }

    function r(e, t) {
        e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t
    }

    function a(e) {
        return null === e || "undefined" == typeof e ? "" + e : {}.toString.call(e).match(/\s([a-z]+)/i)[1].toLowerCase()
    }

    function l() {
        return {
            bindType: f,
            delegateType: f,
            handle: function (e) {
                if (t(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
            }
        }
    }

    function c(e) {
        var n = this,
            i = !1;
        return t(this).one(p.TRANSITION_END, function () {
            i = !0
        }), setTimeout(function () {
            i || p.triggerTransitionEnd(n)
        }, e), this
    }

    function h() {
        t.fn.emulateTransitionEnd = c, t.event.special[p.TRANSITION_END] = l()
    }

    function u(e, t) {
        var n = e.nodeName.toLowerCase();
        if (t.indexOf(n) !== -1) return Rn.indexOf(n) === -1 || Boolean(e.nodeValue.match(qn) || e.nodeValue.match(Qn));
        for (var i = t.filter(function (e) {
                return e instanceof RegExp
            }), o = 0, s = i.length; o < s; o++)
            if (n.match(i[o])) return !0;
        return !1
    }

    function d(e, t, n) {
        if (0 === e.length) return e;
        if (n && "function" == typeof n) return n(e);
        for (var i = new window.DOMParser, o = i.parseFromString(e, "text/html"), s = Object.keys(t), r = [].slice.call(o.body.querySelectorAll("*")), a = function (e, n) {
                var i = r[e],
                    o = i.nodeName.toLowerCase();
                if (s.indexOf(i.nodeName.toLowerCase()) === -1) return i.parentNode.removeChild(i), "continue";
                var a = [].slice.call(i.attributes),
                    l = [].concat(t["*"] || [], t[o] || []);
                a.forEach(function (e) {
                    u(e, l) || i.removeAttribute(e.nodeName)
                })
            }, l = 0, c = r.length; l < c; l++) {
            a(l)
        }
        return o.body.innerHTML
    }
    t = t && Object.prototype.hasOwnProperty.call(t, "default") ? t["default"] : t, n = n && Object.prototype.hasOwnProperty.call(n, "default") ? n["default"] : n;
    var f = "transitionend",
        g = 1e6,
        m = 1e3,
        p = {
            TRANSITION_END: "bsTransitionEnd",
            getUID: function (e) {
                do e += ~~(Math.random() * g); while (document.getElementById(e));
                return e
            },
            getSelectorFromElement: function (e) {
                var t = e.getAttribute("data-target");
                if (!t || "#" === t) {
                    var n = e.getAttribute("href");
                    t = n && "#" !== n ? n.trim() : ""
                }
                try {
                    return document.querySelector(t) ? t : null
                } catch (i) {
                    return null
                }
            },
            getTransitionDurationFromElement: function (e) {
                if (!e) return 0;
                var n = t(e).css("transition-duration"),
                    i = t(e).css("transition-delay"),
                    o = parseFloat(n),
                    s = parseFloat(i);
                return o || s ? (n = n.split(",")[0], i = i.split(",")[0], (parseFloat(n) + parseFloat(i)) * m) : 0
            },
            reflow: function (e) {
                return e.offsetHeight
            },
            triggerTransitionEnd: function (e) {
                t(e).trigger(f)
            },
            supportsTransitionEnd: function () {
                return Boolean(f)
            },
            isElement: function (e) {
                return (e[0] || e).nodeType
            },
            typeCheckConfig: function (e, t, n) {
                for (var i in n)
                    if (Object.prototype.hasOwnProperty.call(n, i)) {
                        var o = n[i],
                            s = t[i],
                            r = s && p.isElement(s) ? "element" : a(s);
                        if (!new RegExp(o).test(r)) throw new Error(e.toUpperCase() + ": " + ('Option "' + i + '" provided type "' + r + '" ') + ('but expected type "' + o + '".'))
                    }
            },
            findShadowRoot: function (e) {
                if (!document.documentElement.attachShadow) return null;
                if ("function" == typeof e.getRootNode) {
                    var t = e.getRootNode();
                    return t instanceof ShadowRoot ? t : null
                }
                return e instanceof ShadowRoot ? e : e.parentNode ? p.findShadowRoot(e.parentNode) : null
            },
            jQueryDetection: function () {
                if ("undefined" == typeof t) throw new TypeError("Bootstrap's JavaScript requires jQuery. jQuery must be included before Bootstrap's JavaScript.");
                var e = t.fn.jquery.split(" ")[0].split("."),
                    n = 1,
                    i = 2,
                    o = 9,
                    s = 1,
                    r = 4;
                if (e[0] < i && e[1] < o || e[0] === n && e[1] === o && e[2] < s || e[0] >= r) throw new Error("Bootstrap's JavaScript requires at least jQuery v1.9.1 but less than v4.0.0")
            }
        };
    p.jQueryDetection(), h();
    var _ = "alert",
        v = "4.5.2",
        y = "bs.alert",
        b = "." + y,
        w = ".data-api",
        T = t.fn[_],
        E = '[data-dismiss="alert"]',
        C = "close" + b,
        S = "closed" + b,
        k = "click" + b + w,
        D = "alert",
        N = "fade",
        $ = "show",
        A = function () {
            function e(e) {
                this._element = e
            }
            var n = e.prototype;
            return n.close = function (e) {
                var t = this._element;
                e && (t = this._getRootElement(e));
                var n = this._triggerCloseEvent(t);
                n.isDefaultPrevented() || this._removeElement(t)
            }, n.dispose = function () {
                t.removeData(this._element, y), this._element = null
            }, n._getRootElement = function (e) {
                var n = p.getSelectorFromElement(e),
                    i = !1;
                return n && (i = document.querySelector(n)), i || (i = t(e).closest("." + D)[0]), i
            }, n._triggerCloseEvent = function (e) {
                var n = t.Event(C);
                return t(e).trigger(n), n
            }, n._removeElement = function (e) {
                var n = this;
                if (t(e).removeClass($), !t(e).hasClass(N)) return void this._destroyElement(e);
                var i = p.getTransitionDurationFromElement(e);
                t(e).one(p.TRANSITION_END, function (t) {
                    return n._destroyElement(e, t)
                }).emulateTransitionEnd(i)
            }, n._destroyElement = function (e) {
                t(e).detach().trigger(S).remove()
            }, e._jQueryInterface = function (n) {
                return this.each(function () {
                    var i = t(this),
                        o = i.data(y);
                    o || (o = new e(this), i.data(y, o)), "close" === n && o[n](this)
                })
            }, e._handleDismiss = function (e) {
                return function (t) {
                    t && t.preventDefault(), e.close(this)
                }
            }, o(e, null, [{
                key: "VERSION",
                get: function () {
                    return v
                }
            }]), e
        }();
    t(document).on(k, E, A._handleDismiss(new A)), t.fn[_] = A._jQueryInterface, t.fn[_].Constructor = A, t.fn[_].noConflict = function () {
        return t.fn[_] = T, A._jQueryInterface
    };
    var I = "button",
        j = "4.5.2",
        O = "bs.button",
        x = "." + O,
        P = ".data-api",
        R = t.fn[I],
        L = "active",
        F = "btn",
        q = "focus",
        Q = '[data-toggle^="button"]',
        H = '[data-toggle="buttons"]',
        B = '[data-toggle="button"]',
        M = '[data-toggle="buttons"] .btn',
        U = 'input:not([type="hidden"])',
        W = ".active",
        V = ".btn",
        K = "click" + x + P,
        X = "focus" + x + P + " " + ("blur" + x + P),
        z = "load" + x + P,
        Y = function () {
            function e(e) {
                this._element = e
            }
            var n = e.prototype;
            return n.toggle = function () {
                var e = !0,
                    n = !0,
                    i = t(this._element).closest(H)[0];
                if (i) {
                    var o = this._element.querySelector(U);
                    if (o) {
                        if ("radio" === o.type)
                            if (o.checked && this._element.classList.contains(L)) e = !1;
                            else {
                                var s = i.querySelector(W);
                                s && t(s).removeClass(L)
                            }
                        e && ("checkbox" !== o.type && "radio" !== o.type || (o.checked = !this._element.classList.contains(L)), t(o).trigger("change")), o.focus(), n = !1
                    }
                }
                this._element.hasAttribute("disabled") || this._element.classList.contains("disabled") || (n && this._element.setAttribute("aria-pressed", !this._element.classList.contains(L)), e && t(this._element).toggleClass(L))
            }, n.dispose = function () {
                t.removeData(this._element, O), this._element = null
            }, e._jQueryInterface = function (n) {
                return this.each(function () {
                    var i = t(this).data(O);
                    i || (i = new e(this), t(this).data(O, i)), "toggle" === n && i[n]()
                })
            }, o(e, null, [{
                key: "VERSION",
                get: function () {
                    return j
                }
            }]), e
        }();
    t(document).on(K, Q, function (e) {
        var n = e.target,
            i = n;
        if (t(n).hasClass(F) || (n = t(n).closest(V)[0]), !n || n.hasAttribute("disabled") || n.classList.contains("disabled")) e.preventDefault();
        else {
            var o = n.querySelector(U);
            if (o && (o.hasAttribute("disabled") || o.classList.contains("disabled"))) return void e.preventDefault();
            ("LABEL" !== i.tagName || o && "checkbox" !== o.type) && Y._jQueryInterface.call(t(n), "toggle")
        }
    }).on(X, Q, function (e) {
        var n = t(e.target).closest(V)[0];
        t(n).toggleClass(q, /^focus(in)?$/.test(e.type))
    }), t(window).on(z, function () {
        for (var e = [].slice.call(document.querySelectorAll(M)), t = 0, n = e.length; t < n; t++) {
            var i = e[t],
                o = i.querySelector(U);
            o.checked || o.hasAttribute("checked") ? i.classList.add(L) : i.classList.remove(L)
        }
        e = [].slice.call(document.querySelectorAll(B));
        for (var s = 0, r = e.length; s < r; s++) {
            var a = e[s];
            "true" === a.getAttribute("aria-pressed") ? a.classList.add(L) : a.classList.remove(L)
        }
    }), t.fn[I] = Y._jQueryInterface, t.fn[I].Constructor = Y, t.fn[I].noConflict = function () {
        return t.fn[I] = R, Y._jQueryInterface
    };
    var G = "carousel",
        J = "4.5.2",
        Z = "bs.carousel",
        ee = "." + Z,
        te = ".data-api",
        ne = t.fn[G],
        ie = 37,
        oe = 39,
        se = 500,
        re = 40,
        ae = {
            interval: 5e3,
            keyboard: !0,
            slide: !1,
            pause: "hover",
            wrap: !0,
            touch: !0
        },
        le = {
            interval: "(number|boolean)",
            keyboard: "boolean",
            slide: "(boolean|string)",
            pause: "(string|boolean)",
            wrap: "boolean",
            touch: "boolean"
        },
        ce = "next",
        he = "prev",
        ue = "left",
        de = "right",
        fe = "slide" + ee,
        ge = "slid" + ee,
        me = "keydown" + ee,
        pe = "mouseenter" + ee,
        _e = "mouseleave" + ee,
        ve = "touchstart" + ee,
        ye = "touchmove" + ee,
        be = "touchend" + ee,
        we = "pointerdown" + ee,
        Te = "pointerup" + ee,
        Ee = "dragstart" + ee,
        Ce = "load" + ee + te,
        Se = "click" + ee + te,
        ke = "carousel",
        De = "active",
        Ne = "slide",
        $e = "carousel-item-right",
        Ae = "carousel-item-left",
        Ie = "carousel-item-next",
        je = "carousel-item-prev",
        Oe = "pointer-event",
        xe = ".active",
        Pe = ".active.carousel-item",
        Re = ".carousel-item",
        Le = ".carousel-item img",
        Fe = ".carousel-item-next, .carousel-item-prev",
        qe = ".carousel-indicators",
        Qe = "[data-slide], [data-slide-to]",
        He = '[data-ride="carousel"]',
        Be = {
            TOUCH: "touch",
            PEN: "pen"
        },
        Me = function () {
            function e(e, t) {
                this._items = null, this._interval = null, this._activeElement = null, this._isPaused = !1, this._isSliding = !1, this.touchTimeout = null, this.touchStartX = 0, this.touchDeltaX = 0, this._config = this._getConfig(t), this._element = e, this._indicatorsElement = this._element.querySelector(qe), this._touchSupported = "ontouchstart" in document.documentElement || navigator.maxTouchPoints > 0, this._pointerEvent = Boolean(window.PointerEvent || window.MSPointerEvent), this._addEventListeners()
            }
            var n = e.prototype;
            return n.next = function () {
                this._isSliding || this._slide(ce)
            }, n.nextWhenVisible = function () {
                !document.hidden && t(this._element).is(":visible") && "hidden" !== t(this._element).css("visibility") && this.next()
            }, n.prev = function () {
                this._isSliding || this._slide(he)
            }, n.pause = function (e) {
                e || (this._isPaused = !0), this._element.querySelector(Fe) && (p.triggerTransitionEnd(this._element), this.cycle(!0)), clearInterval(this._interval), this._interval = null
            }, n.cycle = function (e) {
                e || (this._isPaused = !1), this._interval && (clearInterval(this._interval), this._interval = null), this._config.interval && !this._isPaused && (this._interval = setInterval((document.visibilityState ? this.nextWhenVisible : this.next).bind(this), this._config.interval))
            }, n.to = function (e) {
                var n = this;
                this._activeElement = this._element.querySelector(Pe);
                var i = this._getItemIndex(this._activeElement);
                if (!(e > this._items.length - 1 || e < 0)) {
                    if (this._isSliding) return void t(this._element).one(ge, function () {
                        return n.to(e)
                    });
                    if (i === e) return this.pause(), void this.cycle();
                    var o = e > i ? ce : he;
                    this._slide(o, this._items[e])
                }
            }, n.dispose = function () {
                t(this._element).off(ee), t.removeData(this._element, Z), this._items = null, this._config = null, this._element = null, this._interval = null, this._isPaused = null, this._isSliding = null, this._activeElement = null, this._indicatorsElement = null
            }, n._getConfig = function (e) {
                return e = s({}, ae, e), p.typeCheckConfig(G, e, le), e
            }, n._handleSwipe = function () {
                var e = Math.abs(this.touchDeltaX);
                if (!(e <= re)) {
                    var t = e / this.touchDeltaX;
                    this.touchDeltaX = 0, t > 0 && this.prev(), t < 0 && this.next()
                }
            }, n._addEventListeners = function () {
                var e = this;
                this._config.keyboard && t(this._element).on(me, function (t) {
                    return e._keydown(t)
                }), "hover" === this._config.pause && t(this._element).on(pe, function (t) {
                    return e.pause(t)
                }).on(_e, function (t) {
                    return e.cycle(t)
                }), this._config.touch && this._addTouchEventListeners()
            }, n._addTouchEventListeners = function () {
                var e = this;
                if (this._touchSupported) {
                    var n = function (t) {
                            e._pointerEvent && Be[t.originalEvent.pointerType.toUpperCase()] ? e.touchStartX = t.originalEvent.clientX : e._pointerEvent || (e.touchStartX = t.originalEvent.touches[0].clientX)
                        },
                        i = function (t) {
                            t.originalEvent.touches && t.originalEvent.touches.length > 1 ? e.touchDeltaX = 0 : e.touchDeltaX = t.originalEvent.touches[0].clientX - e.touchStartX
                        },
                        o = function (t) {
                            e._pointerEvent && Be[t.originalEvent.pointerType.toUpperCase()] && (e.touchDeltaX = t.originalEvent.clientX - e.touchStartX), e._handleSwipe(), "hover" === e._config.pause && (e.pause(), e.touchTimeout && clearTimeout(e.touchTimeout), e.touchTimeout = setTimeout(function (t) {
                                return e.cycle(t)
                            }, se + e._config.interval))
                        };
                    t(this._element.querySelectorAll(Le)).on(Ee, function (e) {
                        return e.preventDefault()
                    }), this._pointerEvent ? (t(this._element).on(we, function (e) {
                        return n(e)
                    }), t(this._element).on(Te, function (e) {
                        return o(e)
                    }), this._element.classList.add(Oe)) : (t(this._element).on(ve, function (e) {
                        return n(e)
                    }), t(this._element).on(ye, function (e) {
                        return i(e)
                    }), t(this._element).on(be, function (e) {
                        return o(e)
                    }))
                }
            }, n._keydown = function (e) {
                if (!/input|textarea/i.test(e.target.tagName)) switch (e.which) {
                    case ie:
                        e.preventDefault(), this.prev();
                        break;
                    case oe:
                        e.preventDefault(), this.next()
                }
            }, n._getItemIndex = function (e) {
                return this._items = e && e.parentNode ? [].slice.call(e.parentNode.querySelectorAll(Re)) : [], this._items.indexOf(e)
            }, n._getItemByDirection = function (e, t) {
                var n = e === ce,
                    i = e === he,
                    o = this._getItemIndex(t),
                    s = this._items.length - 1,
                    r = i && 0 === o || n && o === s;
                if (r && !this._config.wrap) return t;
                var a = e === he ? -1 : 1,
                    l = (o + a) % this._items.length;
                return l === -1 ? this._items[this._items.length - 1] : this._items[l]
            }, n._triggerSlideEvent = function (e, n) {
                var i = this._getItemIndex(e),
                    o = this._getItemIndex(this._element.querySelector(Pe)),
                    s = t.Event(fe, {
                        relatedTarget: e,
                        direction: n,
                        from: o,
                        to: i
                    });
                return t(this._element).trigger(s), s
            }, n._setActiveIndicatorElement = function (e) {
                if (this._indicatorsElement) {
                    var n = [].slice.call(this._indicatorsElement.querySelectorAll(xe));
                    t(n).removeClass(De);
                    var i = this._indicatorsElement.children[this._getItemIndex(e)];
                    i && t(i).addClass(De)
                }
            }, n._slide = function (e, n) {
                var i, o, s, r = this,
                    a = this._element.querySelector(Pe),
                    l = this._getItemIndex(a),
                    c = n || a && this._getItemByDirection(e, a),
                    h = this._getItemIndex(c),
                    u = Boolean(this._interval);
                if (e === ce ? (i = Ae, o = Ie, s = ue) : (i = $e, o = je, s = de), c && t(c).hasClass(De)) return void(this._isSliding = !1);
                var d = this._triggerSlideEvent(c, s);
                if (!d.isDefaultPrevented() && a && c) {
                    this._isSliding = !0, u && this.pause(), this._setActiveIndicatorElement(c);
                    var f = t.Event(ge, {
                        relatedTarget: c,
                        direction: s,
                        from: l,
                        to: h
                    });
                    if (t(this._element).hasClass(Ne)) {
                        t(c).addClass(o), p.reflow(c), t(a).addClass(i), t(c).addClass(i);
                        var g = parseInt(c.getAttribute("data-interval"), 10);
                        g ? (this._config.defaultInterval = this._config.defaultInterval || this._config.interval, this._config.interval = g) : this._config.interval = this._config.defaultInterval || this._config.interval;
                        var m = p.getTransitionDurationFromElement(a);
                        t(a).one(p.TRANSITION_END, function () {
                            t(c).removeClass(i + " " + o).addClass(De), t(a).removeClass(De + " " + o + " " + i), r._isSliding = !1, setTimeout(function () {
                                return t(r._element).trigger(f)
                            }, 0)
                        }).emulateTransitionEnd(m)
                    } else t(a).removeClass(De), t(c).addClass(De), this._isSliding = !1, t(this._element).trigger(f);
                    u && this.cycle()
                }
            }, e._jQueryInterface = function (n) {
                return this.each(function () {
                    var i = t(this).data(Z),
                        o = s({}, ae, t(this).data());
                    "object" == typeof n && (o = s({}, o, n));
                    var r = "string" == typeof n ? n : o.slide;
                    if (i || (i = new e(this, o), t(this).data(Z, i)), "number" == typeof n) i.to(n);
                    else if ("string" == typeof r) {
                        if ("undefined" == typeof i[r]) throw new TypeError('No method named "' + r + '"');
                        i[r]()
                    } else o.interval && o.ride && (i.pause(), i.cycle())
                })
            }, e._dataApiClickHandler = function (n) {
                var i = p.getSelectorFromElement(this);
                if (i) {
                    var o = t(i)[0];
                    if (o && t(o).hasClass(ke)) {
                        var r = s({}, t(o).data(), t(this).data()),
                            a = this.getAttribute("data-slide-to");
                        a && (r.interval = !1), e._jQueryInterface.call(t(o), r), a && t(o).data(Z).to(a), n.preventDefault()
                    }
                }
            }, o(e, null, [{
                key: "VERSION",
                get: function () {
                    return J
                }
            }, {
                key: "Default",
                get: function () {
                    return ae
                }
            }]), e
        }();
    t(document).on(Se, Qe, Me._dataApiClickHandler), t(window).on(Ce, function () {
        for (var e = [].slice.call(document.querySelectorAll(He)), n = 0, i = e.length; n < i; n++) {
            var o = t(e[n]);
            Me._jQueryInterface.call(o, o.data())
        }
    }), t.fn[G] = Me._jQueryInterface, t.fn[G].Constructor = Me, t.fn[G].noConflict = function () {
        return t.fn[G] = ne, Me._jQueryInterface
    };
    var Ue = "collapse",
        We = "4.5.2",
        Ve = "bs.collapse",
        Ke = "." + Ve,
        Xe = ".data-api",
        ze = t.fn[Ue],
        Ye = {
            toggle: !0,
            parent: ""
        },
        Ge = {
            toggle: "boolean",
            parent: "(string|element)"
        },
        Je = "show" + Ke,
        Ze = "shown" + Ke,
        et = "hide" + Ke,
        tt = "hidden" + Ke,
        nt = "click" + Ke + Xe,
        it = "show",
        ot = "collapse",
        st = "collapsing",
        rt = "collapsed",
        at = "width",
        lt = "height",
        ct = ".show, .collapsing",
        ht = '[data-toggle="collapse"]',
        ut = function () {
            function e(e, t) {
                this._isTransitioning = !1, this._element = e, this._config = this._getConfig(t), this._triggerArray = [].slice.call(document.querySelectorAll('[data-toggle="collapse"][href="#' + e.id + '"],' + ('[data-toggle="collapse"][data-target="#' + e.id + '"]')));
                for (var n = [].slice.call(document.querySelectorAll(ht)), i = 0, o = n.length; i < o; i++) {
                    var s = n[i],
                        r = p.getSelectorFromElement(s),
                        a = [].slice.call(document.querySelectorAll(r)).filter(function (t) {
                            return t === e
                        });
                    null !== r && a.length > 0 && (this._selector = r, this._triggerArray.push(s))
                }
                this._parent = this._config.parent ? this._getParent() : null, this._config.parent || this._addAriaAndCollapsedClass(this._element, this._triggerArray), this._config.toggle && this.toggle()
            }
            var n = e.prototype;
            return n.toggle = function () {
                t(this._element).hasClass(it) ? this.hide() : this.show()
            }, n.show = function () {
                var n = this;
                if (!this._isTransitioning && !t(this._element).hasClass(it)) {
                    var i, o;
                    if (this._parent && (i = [].slice.call(this._parent.querySelectorAll(ct)).filter(function (e) {
                            return "string" == typeof n._config.parent ? e.getAttribute("data-parent") === n._config.parent : e.classList.contains(ot)
                        }), 0 === i.length && (i = null)), !(i && (o = t(i).not(this._selector).data(Ve), o && o._isTransitioning))) {
                        var s = t.Event(Je);
                        if (t(this._element).trigger(s), !s.isDefaultPrevented()) {
                            i && (e._jQueryInterface.call(t(i).not(this._selector), "hide"), o || t(i).data(Ve, null));
                            var r = this._getDimension();
                            t(this._element).removeClass(ot).addClass(st), this._element.style[r] = 0, this._triggerArray.length && t(this._triggerArray).removeClass(rt).attr("aria-expanded", !0), this.setTransitioning(!0);
                            var a = function () {
                                    t(n._element).removeClass(st).addClass(ot + " " + it), n._element.style[r] = "", n.setTransitioning(!1), t(n._element).trigger(Ze)
                                },
                                l = r[0].toUpperCase() + r.slice(1),
                                c = "scroll" + l,
                                h = p.getTransitionDurationFromElement(this._element);
                            t(this._element).one(p.TRANSITION_END, a).emulateTransitionEnd(h), this._element.style[r] = this._element[c] + "px"
                        }
                    }
                }
            }, n.hide = function () {
                var e = this;
                if (!this._isTransitioning && t(this._element).hasClass(it)) {
                    var n = t.Event(et);
                    if (t(this._element).trigger(n), !n.isDefaultPrevented()) {
                        var i = this._getDimension();
                        this._element.style[i] = this._element.getBoundingClientRect()[i] + "px", p.reflow(this._element), t(this._element).addClass(st).removeClass(ot + " " + it);
                        var o = this._triggerArray.length;
                        if (o > 0)
                            for (var s = 0; s < o; s++) {
                                var r = this._triggerArray[s],
                                    a = p.getSelectorFromElement(r);
                                if (null !== a) {
                                    var l = t([].slice.call(document.querySelectorAll(a)));
                                    l.hasClass(it) || t(r).addClass(rt).attr("aria-expanded", !1)
                                }
                            }
                        this.setTransitioning(!0);
                        var c = function () {
                            e.setTransitioning(!1), t(e._element).removeClass(st).addClass(ot).trigger(tt)
                        };
                        this._element.style[i] = "";
                        var h = p.getTransitionDurationFromElement(this._element);
                        t(this._element).one(p.TRANSITION_END, c).emulateTransitionEnd(h)
                    }
                }
            }, n.setTransitioning = function (e) {
                this._isTransitioning = e
            }, n.dispose = function () {
                t.removeData(this._element, Ve), this._config = null, this._parent = null, this._element = null, this._triggerArray = null, this._isTransitioning = null
            }, n._getConfig = function (e) {
                return e = s({}, Ye, e), e.toggle = Boolean(e.toggle), p.typeCheckConfig(Ue, e, Ge), e
            }, n._getDimension = function () {
                var e = t(this._element).hasClass(at);
                return e ? at : lt
            }, n._getParent = function () {
                var n, i = this;
                p.isElement(this._config.parent) ? (n = this._config.parent, "undefined" != typeof this._config.parent.jquery && (n = this._config.parent[0])) : n = document.querySelector(this._config.parent);
                var o = '[data-toggle="collapse"][data-parent="' + this._config.parent + '"]',
                    s = [].slice.call(n.querySelectorAll(o));
                return t(s).each(function (t, n) {
                    i._addAriaAndCollapsedClass(e._getTargetFromElement(n), [n])
                }), n
            }, n._addAriaAndCollapsedClass = function (e, n) {
                var i = t(e).hasClass(it);
                n.length && t(n).toggleClass(rt, !i).attr("aria-expanded", i)
            }, e._getTargetFromElement = function (e) {
                var t = p.getSelectorFromElement(e);
                return t ? document.querySelector(t) : null
            }, e._jQueryInterface = function (n) {
                return this.each(function () {
                    var i = t(this),
                        o = i.data(Ve),
                        r = s({}, Ye, i.data(), "object" == typeof n && n ? n : {});
                    if (!o && r.toggle && "string" == typeof n && /show|hide/.test(n) && (r.toggle = !1), o || (o = new e(this, r), i.data(Ve, o)), "string" == typeof n) {
                        if ("undefined" == typeof o[n]) throw new TypeError('No method named "' + n + '"');
                        o[n]()
                    }
                })
            }, o(e, null, [{
                key: "VERSION",
                get: function () {
                    return We
                }
            }, {
                key: "Default",
                get: function () {
                    return Ye
                }
            }]), e
        }();
    t(document).on(nt, ht, function (e) {
        "A" === e.currentTarget.tagName && e.preventDefault();
        var n = t(this),
            i = p.getSelectorFromElement(this),
            o = [].slice.call(document.querySelectorAll(i));
        t(o).each(function () {
            var e = t(this),
                i = e.data(Ve),
                o = i ? "toggle" : n.data();
            ut._jQueryInterface.call(e, o)
        })
    }), t.fn[Ue] = ut._jQueryInterface, t.fn[Ue].Constructor = ut, t.fn[Ue].noConflict = function () {
        return t.fn[Ue] = ze, ut._jQueryInterface
    };
    var dt = "dropdown",
        ft = "4.5.2",
        gt = "bs.dropdown",
        mt = "." + gt,
        pt = ".data-api",
        _t = t.fn[dt],
        vt = 27,
        yt = 32,
        bt = 9,
        wt = 38,
        Tt = 40,
        Et = 3,
        Ct = new RegExp(wt + "|" + Tt + "|" + vt),
        St = "hide" + mt,
        kt = "hidden" + mt,
        Dt = "show" + mt,
        Nt = "shown" + mt,
        $t = "click" + mt,
        At = "click" + mt + pt,
        It = "keydown" + mt + pt,
        jt = "keyup" + mt + pt,
        Ot = "disabled",
        xt = "show",
        Pt = "dropup",
        Rt = "dropright",
        Lt = "dropleft",
        Ft = "dropdown-menu-right",
        qt = "position-static",
        Qt = '[data-toggle="dropdown"]',
        Ht = ".dropdown form",
        Bt = ".dropdown-menu",
        Mt = ".navbar-nav",
        Ut = ".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)",
        Wt = "top-start",
        Vt = "top-end",
        Kt = "bottom-start",
        Xt = "bottom-end",
        zt = "right-start",
        Yt = "left-start",
        Gt = {
            offset: 0,
            flip: !0,
            boundary: "scrollParent",
            reference: "toggle",
            display: "dynamic",
            popperConfig: null
        },
        Jt = {
            offset: "(number|string|function)",
            flip: "boolean",
            boundary: "(string|element)",
            reference: "(string|element)",
            display: "string",
            popperConfig: "(null|object)"
        },
        Zt = function () {
            function e(e, t) {
                this._element = e, this._popper = null, this._config = this._getConfig(t), this._menu = this._getMenuElement(), this._inNavbar = this._detectNavbar(), this._addEventListeners()
            }
            var i = e.prototype;
            return i.toggle = function () {
                if (!this._element.disabled && !t(this._element).hasClass(Ot)) {
                    var n = t(this._menu).hasClass(xt);
                    e._clearMenus(), n || this.show(!0)
                }
            }, i.show = function (i) {
                if (void 0 === i && (i = !1), !(this._element.disabled || t(this._element).hasClass(Ot) || t(this._menu).hasClass(xt))) {
                    var o = {
                            relatedTarget: this._element
                        },
                        s = t.Event(Dt, o),
                        r = e._getParentFromElement(this._element);
                    if (t(r).trigger(s), !s.isDefaultPrevented()) {
                        if (!this._inNavbar && i) {
                            if ("undefined" == typeof n) throw new TypeError("Bootstrap's dropdowns require Popper.js (https://popper.js.org/)");
                            var a = this._element;
                            "parent" === this._config.reference ? a = r : p.isElement(this._config.reference) && (a = this._config.reference, "undefined" != typeof this._config.reference.jquery && (a = this._config.reference[0])), "scrollParent" !== this._config.boundary && t(r).addClass(qt), this._popper = new n(a, this._menu, this._getPopperConfig())
                        }
                        "ontouchstart" in document.documentElement && 0 === t(r).closest(Mt).length && t(document.body).children().on("mouseover", null, t.noop), this._element.focus(), this._element.setAttribute("aria-expanded", !0), t(this._menu).toggleClass(xt), t(r).toggleClass(xt).trigger(t.Event(Nt, o))
                    }
                }
            }, i.hide = function () {
                if (!this._element.disabled && !t(this._element).hasClass(Ot) && t(this._menu).hasClass(xt)) {
                    var n = {
                            relatedTarget: this._element
                        },
                        i = t.Event(St, n),
                        o = e._getParentFromElement(this._element);
                    t(o).trigger(i), i.isDefaultPrevented() || (this._popper && this._popper.destroy(), t(this._menu).toggleClass(xt), t(o).toggleClass(xt).trigger(t.Event(kt, n)))
                }
            }, i.dispose = function () {
                t.removeData(this._element, gt), t(this._element).off(mt), this._element = null, this._menu = null, null !== this._popper && (this._popper.destroy(), this._popper = null)
            }, i.update = function () {
                this._inNavbar = this._detectNavbar(), null !== this._popper && this._popper.scheduleUpdate()
            }, i._addEventListeners = function () {
                var e = this;
                t(this._element).on($t, function (t) {
                    t.preventDefault(), t.stopPropagation(), e.toggle()
                })
            }, i._getConfig = function (e) {
                return e = s({}, this.constructor.Default, t(this._element).data(), e), p.typeCheckConfig(dt, e, this.constructor.DefaultType), e
            }, i._getMenuElement = function () {
                if (!this._menu) {
                    var t = e._getParentFromElement(this._element);
                    t && (this._menu = t.querySelector(Bt))
                }
                return this._menu
            }, i._getPlacement = function () {
                var e = t(this._element.parentNode),
                    n = Kt;
                return e.hasClass(Pt) ? n = t(this._menu).hasClass(Ft) ? Vt : Wt : e.hasClass(Rt) ? n = zt : e.hasClass(Lt) ? n = Yt : t(this._menu).hasClass(Ft) && (n = Xt), n
            }, i._detectNavbar = function () {
                return t(this._element).closest(".navbar").length > 0
            }, i._getOffset = function () {
                var e = this,
                    t = {};
                return "function" == typeof this._config.offset ? t.fn = function (t) {
                    return t.offsets = s({}, t.offsets, e._config.offset(t.offsets, e._element) || {}), t
                } : t.offset = this._config.offset, t
            }, i._getPopperConfig = function () {
                var e = {
                    placement: this._getPlacement(),
                    modifiers: {
                        offset: this._getOffset(),
                        flip: {
                            enabled: this._config.flip
                        },
                        preventOverflow: {
                            boundariesElement: this._config.boundary
                        }
                    }
                };
                return "static" === this._config.display && (e.modifiers.applyStyle = {
                    enabled: !1
                }), s({}, e, this._config.popperConfig)
            }, e._jQueryInterface = function (n) {
                return this.each(function () {
                    var i = t(this).data(gt),
                        o = "object" == typeof n ? n : null;
                    if (i || (i = new e(this, o), t(this).data(gt, i)), "string" == typeof n) {
                        if ("undefined" == typeof i[n]) throw new TypeError('No method named "' + n + '"');
                        i[n]()
                    }
                })
            }, e._clearMenus = function (n) {
                if (!n || n.which !== Et && ("keyup" !== n.type || n.which === bt))
                    for (var i = [].slice.call(document.querySelectorAll(Qt)), o = 0, s = i.length; o < s; o++) {
                        var r = e._getParentFromElement(i[o]),
                            a = t(i[o]).data(gt),
                            l = {
                                relatedTarget: i[o]
                            };
                        if (n && "click" === n.type && (l.clickEvent = n), a) {
                            var c = a._menu;
                            if (t(r).hasClass(xt) && !(n && ("click" === n.type && /input|textarea/i.test(n.target.tagName) || "keyup" === n.type && n.which === bt) && t.contains(r, n.target))) {
                                var h = t.Event(St, l);
                                t(r).trigger(h), h.isDefaultPrevented() || ("ontouchstart" in document.documentElement && t(document.body).children().off("mouseover", null, t.noop), i[o].setAttribute("aria-expanded", "false"), a._popper && a._popper.destroy(), t(c).removeClass(xt), t(r).removeClass(xt).trigger(t.Event(kt, l)))
                            }
                        }
                    }
            }, e._getParentFromElement = function (e) {
                var t, n = p.getSelectorFromElement(e);
                return n && (t = document.querySelector(n)), t || e.parentNode
            }, e._dataApiKeydownHandler = function (n) {
                if ((/input|textarea/i.test(n.target.tagName) ? !(n.which === yt || n.which !== vt && (n.which !== Tt && n.which !== wt || t(n.target).closest(Bt).length)) : Ct.test(n.which)) && !this.disabled && !t(this).hasClass(Ot)) {
                    var i = e._getParentFromElement(this),
                        o = t(i).hasClass(xt);
                    if (o || n.which !== vt) {
                        if (n.preventDefault(), n.stopPropagation(), !o || o && (n.which === vt || n.which === yt)) return n.which === vt && t(i.querySelector(Qt)).trigger("focus"), void t(this).trigger("click");
                        var s = [].slice.call(i.querySelectorAll(Ut)).filter(function (e) {
                            return t(e).is(":visible")
                        });
                        if (0 !== s.length) {
                            var r = s.indexOf(n.target);
                            n.which === wt && r > 0 && r--, n.which === Tt && r < s.length - 1 && r++, r < 0 && (r = 0), s[r].focus()
                        }
                    }
                }
            }, o(e, null, [{
                key: "VERSION",
                get: function () {
                    return ft
                }
            }, {
                key: "Default",
                get: function () {
                    return Gt
                }
            }, {
                key: "DefaultType",
                get: function () {
                    return Jt
                }
            }]), e
        }();
    t(document).on(It, Qt, Zt._dataApiKeydownHandler).on(It, Bt, Zt._dataApiKeydownHandler).on(At + " " + jt, Zt._clearMenus).on(At, Qt, function (e) {
        e.preventDefault(), e.stopPropagation(), Zt._jQueryInterface.call(t(this), "toggle")
    }).on(At, Ht, function (e) {
        e.stopPropagation()
    }), t.fn[dt] = Zt._jQueryInterface, t.fn[dt].Constructor = Zt, t.fn[dt].noConflict = function () {
        return t.fn[dt] = _t, Zt._jQueryInterface
    };
    var en = "modal",
        tn = "4.5.2",
        nn = "bs.modal",
        on = "." + nn,
        sn = ".data-api",
        rn = t.fn[en],
        an = 27,
        ln = {
            backdrop: !0,
            keyboard: !0,
            focus: !0,
            show: !0
        },
        cn = {
            backdrop: "(boolean|string)",
            keyboard: "boolean",
            focus: "boolean",
            show: "boolean"
        },
        hn = "hide" + on,
        un = "hidePrevented" + on,
        dn = "hidden" + on,
        fn = "show" + on,
        gn = "shown" + on,
        mn = "focusin" + on,
        pn = "resize" + on,
        _n = "click.dismiss" + on,
        vn = "keydown.dismiss" + on,
        yn = "mouseup.dismiss" + on,
        bn = "mousedown.dismiss" + on,
        wn = "click" + on + sn,
        Tn = "modal-dialog-scrollable",
        En = "modal-scrollbar-measure",
        Cn = "modal-backdrop",
        Sn = "modal-open",
        kn = "fade",
        Dn = "show",
        Nn = "modal-static",
        $n = ".modal-dialog",
        An = ".modal-body",
        In = '[data-toggle="modal"]',
        jn = '[data-dismiss="modal"]',
        On = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top",
        xn = ".sticky-top",
        Pn = function () {
            function e(e, t) {
                this._config = this._getConfig(t), this._element = e, this._dialog = e.querySelector($n), this._backdrop = null, this._isShown = !1, this._isBodyOverflowing = !1, this._ignoreBackdropClick = !1, this._isTransitioning = !1, this._scrollbarWidth = 0
            }
            var n = e.prototype;
            return n.toggle = function (e) {
                return this._isShown ? this.hide() : this.show(e)
            }, n.show = function (e) {
                var n = this;
                if (!this._isShown && !this._isTransitioning) {
                    t(this._element).hasClass(kn) && (this._isTransitioning = !0);
                    var i = t.Event(fn, {
                        relatedTarget: e
                    });
                    t(this._element).trigger(i), this._isShown || i.isDefaultPrevented() || (this._isShown = !0, this._checkScrollbar(), this._setScrollbar(), this._adjustDialog(), this._setEscapeEvent(), this._setResizeEvent(), t(this._element).on(_n, jn, function (e) {
                        return n.hide(e)
                    }), t(this._dialog).on(bn, function () {
                        t(n._element).one(yn, function (e) {
                            t(e.target).is(n._element) && (n._ignoreBackdropClick = !0)
                        })
                    }), this._showBackdrop(function () {
                        return n._showElement(e)
                    }))
                }
            }, n.hide = function (e) {
                var n = this;
                if (e && e.preventDefault(), this._isShown && !this._isTransitioning) {
                    var i = t.Event(hn);
                    if (t(this._element).trigger(i), this._isShown && !i.isDefaultPrevented()) {
                        this._isShown = !1;
                        var o = t(this._element).hasClass(kn);
                        if (o && (this._isTransitioning = !0), this._setEscapeEvent(), this._setResizeEvent(), t(document).off(mn), t(this._element).removeClass(Dn), t(this._element).off(_n), t(this._dialog).off(bn), o) {
                            var s = p.getTransitionDurationFromElement(this._element);
                            t(this._element).one(p.TRANSITION_END, function (e) {
                                return n._hideModal(e)
                            }).emulateTransitionEnd(s)
                        } else this._hideModal()
                    }
                }
            }, n.dispose = function () {
                [window, this._element, this._dialog].forEach(function (e) {
                    return t(e).off(on)
                }), t(document).off(mn), t.removeData(this._element, nn), this._config = null, this._element = null, this._dialog = null, this._backdrop = null, this._isShown = null, this._isBodyOverflowing = null, this._ignoreBackdropClick = null, this._isTransitioning = null, this._scrollbarWidth = null
            }, n.handleUpdate = function () {
                this._adjustDialog()
            }, n._getConfig = function (e) {
                return e = s({}, ln, e), p.typeCheckConfig(en, e, cn), e
            }, n._triggerBackdropTransition = function () {
                var e = this;
                if ("static" === this._config.backdrop) {
                    var n = t.Event(un);
                    if (t(this._element).trigger(n), n.defaultPrevented) return;
                    var i = this._element.scrollHeight > document.documentElement.clientHeight;
                    i || (this._element.style.overflowY = "hidden"), this._element.classList.add(Nn);
                    var o = p.getTransitionDurationFromElement(this._dialog);
                    t(this._element).off(p.TRANSITION_END), t(this._element).one(p.TRANSITION_END, function () {
                        e._element.classList.remove(Nn), i || t(e._element).one(p.TRANSITION_END, function () {
                            e._element.style.overflowY = ""
                        }).emulateTransitionEnd(e._element, o)
                    }).emulateTransitionEnd(o), this._element.focus()
                } else this.hide()
            }, n._showElement = function (e) {
                var n = this,
                    i = t(this._element).hasClass(kn),
                    o = this._dialog ? this._dialog.querySelector(An) : null;
                this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE || document.body.appendChild(this._element), this._element.style.display = "block", this._element.removeAttribute("aria-hidden"), this._element.setAttribute("aria-modal", !0), this._element.setAttribute("role", "dialog"), t(this._dialog).hasClass(Tn) && o ? o.scrollTop = 0 : this._element.scrollTop = 0, i && p.reflow(this._element), t(this._element).addClass(Dn), this._config.focus && this._enforceFocus();
                var s = t.Event(gn, {
                        relatedTarget: e
                    }),
                    r = function () {
                        n._config.focus && n._element.focus(), n._isTransitioning = !1, t(n._element).trigger(s)
                    };
                if (i) {
                    var a = p.getTransitionDurationFromElement(this._dialog);
                    t(this._dialog).one(p.TRANSITION_END, r).emulateTransitionEnd(a)
                } else r()
            }, n._enforceFocus = function () {
                var e = this;
                t(document).off(mn).on(mn, function (n) {
                    document !== n.target && e._element !== n.target && 0 === t(e._element).has(n.target).length && e._element.focus()
                })
            }, n._setEscapeEvent = function () {
                var e = this;
                this._isShown ? t(this._element).on(vn, function (t) {
                    e._config.keyboard && t.which === an ? (t.preventDefault(), e.hide()) : e._config.keyboard || t.which !== an || e._triggerBackdropTransition()
                }) : this._isShown || t(this._element).off(vn)
            }, n._setResizeEvent = function () {
                var e = this;
                this._isShown ? t(window).on(pn, function (t) {
                    return e.handleUpdate(t)
                }) : t(window).off(pn)
            }, n._hideModal = function () {
                var e = this;
                this._element.style.display = "none", this._element.setAttribute("aria-hidden", !0), this._element.removeAttribute("aria-modal"), this._element.removeAttribute("role"), this._isTransitioning = !1,
                    this._showBackdrop(function () {
                        t(document.body).removeClass(Sn), e._resetAdjustments(), e._resetScrollbar(), t(e._element).trigger(dn)
                    })
            }, n._removeBackdrop = function () {
                this._backdrop && (t(this._backdrop).remove(), this._backdrop = null)
            }, n._showBackdrop = function (e) {
                var n = this,
                    i = t(this._element).hasClass(kn) ? kn : "";
                if (this._isShown && this._config.backdrop) {
                    if (this._backdrop = document.createElement("div"), this._backdrop.className = Cn, i && this._backdrop.classList.add(i), t(this._backdrop).appendTo(document.body), t(this._element).on(_n, function (e) {
                            return n._ignoreBackdropClick ? void(n._ignoreBackdropClick = !1) : void(e.target === e.currentTarget && n._triggerBackdropTransition())
                        }), i && p.reflow(this._backdrop), t(this._backdrop).addClass(Dn), !e) return;
                    if (!i) return void e();
                    var o = p.getTransitionDurationFromElement(this._backdrop);
                    t(this._backdrop).one(p.TRANSITION_END, e).emulateTransitionEnd(o)
                } else if (!this._isShown && this._backdrop) {
                    t(this._backdrop).removeClass(Dn);
                    var s = function () {
                        n._removeBackdrop(), e && e()
                    };
                    if (t(this._element).hasClass(kn)) {
                        var r = p.getTransitionDurationFromElement(this._backdrop);
                        t(this._backdrop).one(p.TRANSITION_END, s).emulateTransitionEnd(r)
                    } else s()
                } else e && e()
            }, n._adjustDialog = function () {
                var e = this._element.scrollHeight > document.documentElement.clientHeight;
                !this._isBodyOverflowing && e && (this._element.style.paddingLeft = this._scrollbarWidth + "px"), this._isBodyOverflowing && !e && (this._element.style.paddingRight = this._scrollbarWidth + "px")
            }, n._resetAdjustments = function () {
                this._element.style.paddingLeft = "", this._element.style.paddingRight = ""
            }, n._checkScrollbar = function () {
                var e = document.body.getBoundingClientRect();
                this._isBodyOverflowing = Math.round(e.left + e.right) < window.innerWidth, this._scrollbarWidth = this._getScrollbarWidth()
            }, n._setScrollbar = function () {
                var e = this;
                if (this._isBodyOverflowing) {
                    var n = [].slice.call(document.querySelectorAll(On)),
                        i = [].slice.call(document.querySelectorAll(xn));
                    t(n).each(function (n, i) {
                        var o = i.style.paddingRight,
                            s = t(i).css("padding-right");
                        t(i).data("padding-right", o).css("padding-right", parseFloat(s) + e._scrollbarWidth + "px")
                    }), t(i).each(function (n, i) {
                        var o = i.style.marginRight,
                            s = t(i).css("margin-right");
                        t(i).data("margin-right", o).css("margin-right", parseFloat(s) - e._scrollbarWidth + "px")
                    });
                    var o = document.body.style.paddingRight,
                        s = t(document.body).css("padding-right");
                    t(document.body).data("padding-right", o).css("padding-right", parseFloat(s) + this._scrollbarWidth + "px")
                }
                t(document.body).addClass(Sn)
            }, n._resetScrollbar = function () {
                var e = [].slice.call(document.querySelectorAll(On));
                t(e).each(function (e, n) {
                    var i = t(n).data("padding-right");
                    t(n).removeData("padding-right"), n.style.paddingRight = i ? i : ""
                });
                var n = [].slice.call(document.querySelectorAll("" + xn));
                t(n).each(function (e, n) {
                    var i = t(n).data("margin-right");
                    "undefined" != typeof i && t(n).css("margin-right", i).removeData("margin-right")
                });
                var i = t(document.body).data("padding-right");
                t(document.body).removeData("padding-right"), document.body.style.paddingRight = i ? i : ""
            }, n._getScrollbarWidth = function () {
                var e = document.createElement("div");
                e.className = En, document.body.appendChild(e);
                var t = e.getBoundingClientRect().width - e.clientWidth;
                return document.body.removeChild(e), t
            }, e._jQueryInterface = function (n, i) {
                return this.each(function () {
                    var o = t(this).data(nn),
                        r = s({}, ln, t(this).data(), "object" == typeof n && n ? n : {});
                    if (o || (o = new e(this, r), t(this).data(nn, o)), "string" == typeof n) {
                        if ("undefined" == typeof o[n]) throw new TypeError('No method named "' + n + '"');
                        o[n](i)
                    } else r.show && o.show(i)
                })
            }, o(e, null, [{
                key: "VERSION",
                get: function () {
                    return tn
                }
            }, {
                key: "Default",
                get: function () {
                    return ln
                }
            }]), e
        }();
    t(document).on(wn, In, function (e) {
        var n, i = this,
            o = p.getSelectorFromElement(this);
        o && (n = document.querySelector(o));
        var r = t(n).data(nn) ? "toggle" : s({}, t(n).data(), t(this).data());
        "A" !== this.tagName && "AREA" !== this.tagName || e.preventDefault();
        var a = t(n).one(fn, function (e) {
            e.isDefaultPrevented() || a.one(dn, function () {
                t(i).is(":visible") && i.focus()
            })
        });
        Pn._jQueryInterface.call(t(n), r, this)
    }), t.fn[en] = Pn._jQueryInterface, t.fn[en].Constructor = Pn, t.fn[en].noConflict = function () {
        return t.fn[en] = rn, Pn._jQueryInterface
    };
    var Rn = ["background", "cite", "href", "itemtype", "longdesc", "poster", "src", "xlink:href"],
        Ln = /^aria-[\w-]*$/i,
        Fn = {
            "*": ["class", "dir", "id", "lang", "role", Ln],
            a: ["target", "href", "title", "rel"],
            area: [],
            b: [],
            br: [],
            col: [],
            code: [],
            div: [],
            em: [],
            hr: [],
            h1: [],
            h2: [],
            h3: [],
            h4: [],
            h5: [],
            h6: [],
            i: [],
            img: ["src", "srcset", "alt", "title", "width", "height"],
            li: [],
            ol: [],
            p: [],
            pre: [],
            s: [],
            small: [],
            span: [],
            sub: [],
            sup: [],
            strong: [],
            u: [],
            ul: []
        },
        qn = /^(?:(?:https?|mailto|ftp|tel|file):|[^#&\/:?]*(?:[#\/?]|$))/gi,
        Qn = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[\d+\/a-z]+=*$/i,
        Hn = "tooltip",
        Bn = "4.5.2",
        Mn = "bs.tooltip",
        Un = "." + Mn,
        Wn = t.fn[Hn],
        Vn = "bs-tooltip",
        Kn = new RegExp("(^|\\s)" + Vn + "\\S+", "g"),
        Xn = ["sanitize", "whiteList", "sanitizeFn"],
        zn = {
            animation: "boolean",
            template: "string",
            title: "(string|element|function)",
            trigger: "string",
            delay: "(number|object)",
            html: "boolean",
            selector: "(string|boolean)",
            placement: "(string|function)",
            offset: "(number|string|function)",
            container: "(string|element|boolean)",
            fallbackPlacement: "(string|array)",
            boundary: "(string|element)",
            sanitize: "boolean",
            sanitizeFn: "(null|function)",
            whiteList: "object",
            popperConfig: "(null|object)"
        },
        Yn = {
            AUTO: "auto",
            TOP: "top",
            RIGHT: "right",
            BOTTOM: "bottom",
            LEFT: "left"
        },
        Gn = {
            animation: !0,
            template: '<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
            trigger: "hover focus",
            title: "",
            delay: 0,
            html: !1,
            selector: !1,
            placement: "top",
            offset: 0,
            container: !1,
            fallbackPlacement: "flip",
            boundary: "scrollParent",
            sanitize: !0,
            sanitizeFn: null,
            whiteList: Fn,
            popperConfig: null
        },
        Jn = "show",
        Zn = "out",
        ei = {
            HIDE: "hide" + Un,
            HIDDEN: "hidden" + Un,
            SHOW: "show" + Un,
            SHOWN: "shown" + Un,
            INSERTED: "inserted" + Un,
            CLICK: "click" + Un,
            FOCUSIN: "focusin" + Un,
            FOCUSOUT: "focusout" + Un,
            MOUSEENTER: "mouseenter" + Un,
            MOUSELEAVE: "mouseleave" + Un
        },
        ti = "fade",
        ni = "show",
        ii = ".tooltip-inner",
        oi = ".arrow",
        si = "hover",
        ri = "focus",
        ai = "click",
        li = "manual",
        ci = function () {
            function e(e, t) {
                if ("undefined" == typeof n) throw new TypeError("Bootstrap's tooltips require Popper.js (https://popper.js.org/)");
                this._isEnabled = !0, this._timeout = 0, this._hoverState = "", this._activeTrigger = {}, this._popper = null, this.element = e, this.config = this._getConfig(t), this.tip = null, this._setListeners()
            }
            var i = e.prototype;
            return i.enable = function () {
                this._isEnabled = !0
            }, i.disable = function () {
                this._isEnabled = !1
            }, i.toggleEnabled = function () {
                this._isEnabled = !this._isEnabled
            }, i.toggle = function (e) {
                if (this._isEnabled)
                    if (e) {
                        var n = this.constructor.DATA_KEY,
                            i = t(e.currentTarget).data(n);
                        i || (i = new this.constructor(e.currentTarget, this._getDelegateConfig()), t(e.currentTarget).data(n, i)), i._activeTrigger.click = !i._activeTrigger.click, i._isWithActiveTrigger() ? i._enter(null, i) : i._leave(null, i)
                    } else {
                        if (t(this.getTipElement()).hasClass(ni)) return void this._leave(null, this);
                        this._enter(null, this)
                    }
            }, i.dispose = function () {
                clearTimeout(this._timeout), t.removeData(this.element, this.constructor.DATA_KEY), t(this.element).off(this.constructor.EVENT_KEY), t(this.element).closest(".modal").off("hide.bs.modal", this._hideModalHandler), this.tip && t(this.tip).remove(), this._isEnabled = null, this._timeout = null, this._hoverState = null, this._activeTrigger = null, this._popper && this._popper.destroy(), this._popper = null, this.element = null, this.config = null, this.tip = null
            }, i.show = function () {
                var e = this;
                if ("none" === t(this.element).css("display")) throw new Error("Please use show on visible elements");
                var i = t.Event(this.constructor.Event.SHOW);
                if (this.isWithContent() && this._isEnabled) {
                    t(this.element).trigger(i);
                    var o = p.findShadowRoot(this.element),
                        s = t.contains(null !== o ? o : this.element.ownerDocument.documentElement, this.element);
                    if (i.isDefaultPrevented() || !s) return;
                    var r = this.getTipElement(),
                        a = p.getUID(this.constructor.NAME);
                    r.setAttribute("id", a), this.element.setAttribute("aria-describedby", a), this.setContent(), this.config.animation && t(r).addClass(ti);
                    var l = "function" == typeof this.config.placement ? this.config.placement.call(this, r, this.element) : this.config.placement,
                        c = this._getAttachment(l);
                    this.addAttachmentClass(c);
                    var h = this._getContainer();
                    t(r).data(this.constructor.DATA_KEY, this), t.contains(this.element.ownerDocument.documentElement, this.tip) || t(r).appendTo(h), t(this.element).trigger(this.constructor.Event.INSERTED), this._popper = new n(this.element, r, this._getPopperConfig(c)), t(r).addClass(ni), "ontouchstart" in document.documentElement && t(document.body).children().on("mouseover", null, t.noop);
                    var u = function () {
                        e.config.animation && e._fixTransition();
                        var n = e._hoverState;
                        e._hoverState = null, t(e.element).trigger(e.constructor.Event.SHOWN), n === Zn && e._leave(null, e)
                    };
                    if (t(this.tip).hasClass(ti)) {
                        var d = p.getTransitionDurationFromElement(this.tip);
                        t(this.tip).one(p.TRANSITION_END, u).emulateTransitionEnd(d)
                    } else u()
                }
            }, i.hide = function (e) {
                var n = this,
                    i = this.getTipElement(),
                    o = t.Event(this.constructor.Event.HIDE),
                    s = function () {
                        n._hoverState !== Jn && i.parentNode && i.parentNode.removeChild(i), n._cleanTipClass(), n.element.removeAttribute("aria-describedby"), t(n.element).trigger(n.constructor.Event.HIDDEN), null !== n._popper && n._popper.destroy(), e && e()
                    };
                if (t(this.element).trigger(o), !o.isDefaultPrevented()) {
                    if (t(i).removeClass(ni), "ontouchstart" in document.documentElement && t(document.body).children().off("mouseover", null, t.noop), this._activeTrigger[ai] = !1, this._activeTrigger[ri] = !1, this._activeTrigger[si] = !1, t(this.tip).hasClass(ti)) {
                        var r = p.getTransitionDurationFromElement(i);
                        t(i).one(p.TRANSITION_END, s).emulateTransitionEnd(r)
                    } else s();
                    this._hoverState = ""
                }
            }, i.update = function () {
                null !== this._popper && this._popper.scheduleUpdate()
            }, i.isWithContent = function () {
                return Boolean(this.getTitle())
            }, i.addAttachmentClass = function (e) {
                t(this.getTipElement()).addClass(Vn + "-" + e)
            }, i.getTipElement = function () {
                return this.tip = this.tip || t(this.config.template)[0], this.tip
            }, i.setContent = function () {
                var e = this.getTipElement();
                this.setElementContent(t(e.querySelectorAll(ii)), this.getTitle()), t(e).removeClass(ti + " " + ni)
            }, i.setElementContent = function (e, n) {
                return "object" == typeof n && (n.nodeType || n.jquery) ? void(this.config.html ? t(n).parent().is(e) || e.empty().append(n) : e.text(t(n).text())) : void(this.config.html ? (this.config.sanitize && (n = d(n, this.config.whiteList, this.config.sanitizeFn)), e.html(n)) : e.text(n))
            }, i.getTitle = function () {
                var e = this.element.getAttribute("data-original-title");
                return e || (e = "function" == typeof this.config.title ? this.config.title.call(this.element) : this.config.title), e
            }, i._getPopperConfig = function (e) {
                var t = this,
                    n = {
                        placement: e,
                        modifiers: {
                            offset: this._getOffset(),
                            flip: {
                                behavior: this.config.fallbackPlacement
                            },
                            arrow: {
                                element: oi
                            },
                            preventOverflow: {
                                boundariesElement: this.config.boundary
                            }
                        },
                        onCreate: function (e) {
                            e.originalPlacement !== e.placement && t._handlePopperPlacementChange(e)
                        },
                        onUpdate: function (e) {
                            return t._handlePopperPlacementChange(e)
                        }
                    };
                return s({}, n, this.config.popperConfig)
            }, i._getOffset = function () {
                var e = this,
                    t = {};
                return "function" == typeof this.config.offset ? t.fn = function (t) {
                    return t.offsets = s({}, t.offsets, e.config.offset(t.offsets, e.element) || {}), t
                } : t.offset = this.config.offset, t
            }, i._getContainer = function () {
                return this.config.container === !1 ? document.body : p.isElement(this.config.container) ? t(this.config.container) : t(document).find(this.config.container)
            }, i._getAttachment = function (e) {
                return Yn[e.toUpperCase()]
            }, i._setListeners = function () {
                var e = this,
                    n = this.config.trigger.split(" ");
                n.forEach(function (n) {
                    if ("click" === n) t(e.element).on(e.constructor.Event.CLICK, e.config.selector, function (t) {
                        return e.toggle(t)
                    });
                    else if (n !== li) {
                        var i = n === si ? e.constructor.Event.MOUSEENTER : e.constructor.Event.FOCUSIN,
                            o = n === si ? e.constructor.Event.MOUSELEAVE : e.constructor.Event.FOCUSOUT;
                        t(e.element).on(i, e.config.selector, function (t) {
                            return e._enter(t)
                        }).on(o, e.config.selector, function (t) {
                            return e._leave(t)
                        })
                    }
                }), this._hideModalHandler = function () {
                    e.element && e.hide()
                }, t(this.element).closest(".modal").on("hide.bs.modal", this._hideModalHandler), this.config.selector ? this.config = s({}, this.config, {
                    trigger: "manual",
                    selector: ""
                }) : this._fixTitle()
            }, i._fixTitle = function () {
                var e = typeof this.element.getAttribute("data-original-title");
                (this.element.getAttribute("title") || "string" !== e) && (this.element.setAttribute("data-original-title", this.element.getAttribute("title") || ""), this.element.setAttribute("title", ""))
            }, i._enter = function (e, n) {
                var i = this.constructor.DATA_KEY;
                return n = n || t(e.currentTarget).data(i), n || (n = new this.constructor(e.currentTarget, this._getDelegateConfig()), t(e.currentTarget).data(i, n)), e && (n._activeTrigger["focusin" === e.type ? ri : si] = !0), t(n.getTipElement()).hasClass(ni) || n._hoverState === Jn ? void(n._hoverState = Jn) : (clearTimeout(n._timeout), n._hoverState = Jn, n.config.delay && n.config.delay.show ? void(n._timeout = setTimeout(function () {
                    n._hoverState === Jn && n.show()
                }, n.config.delay.show)) : void n.show())
            }, i._leave = function (e, n) {
                var i = this.constructor.DATA_KEY;
                if (n = n || t(e.currentTarget).data(i), n || (n = new this.constructor(e.currentTarget, this._getDelegateConfig()), t(e.currentTarget).data(i, n)), e && (n._activeTrigger["focusout" === e.type ? ri : si] = !1), !n._isWithActiveTrigger()) return clearTimeout(n._timeout), n._hoverState = Zn, n.config.delay && n.config.delay.hide ? void(n._timeout = setTimeout(function () {
                    n._hoverState === Zn && n.hide()
                }, n.config.delay.hide)) : void n.hide()
            }, i._isWithActiveTrigger = function () {
                for (var e in this._activeTrigger)
                    if (this._activeTrigger[e]) return !0;
                return !1
            }, i._getConfig = function (e) {
                var n = t(this.element).data();
                return Object.keys(n).forEach(function (e) {
                    Xn.indexOf(e) !== -1 && delete n[e]
                }), e = s({}, this.constructor.Default, n, "object" == typeof e && e ? e : {}), "number" == typeof e.delay && (e.delay = {
                    show: e.delay,
                    hide: e.delay
                }), "number" == typeof e.title && (e.title = e.title.toString()), "number" == typeof e.content && (e.content = e.content.toString()), p.typeCheckConfig(Hn, e, this.constructor.DefaultType), e.sanitize && (e.template = d(e.template, e.whiteList, e.sanitizeFn)), e
            }, i._getDelegateConfig = function () {
                var e = {};
                if (this.config)
                    for (var t in this.config) this.constructor.Default[t] !== this.config[t] && (e[t] = this.config[t]);
                return e
            }, i._cleanTipClass = function () {
                var e = t(this.getTipElement()),
                    n = e.attr("class").match(Kn);
                null !== n && n.length && e.removeClass(n.join(""))
            }, i._handlePopperPlacementChange = function (e) {
                this.tip = e.instance.popper, this._cleanTipClass(), this.addAttachmentClass(this._getAttachment(e.placement))
            }, i._fixTransition = function () {
                var e = this.getTipElement(),
                    n = this.config.animation;
                null === e.getAttribute("x-placement") && (t(e).removeClass(ti), this.config.animation = !1, this.hide(), this.show(), this.config.animation = n)
            }, e._jQueryInterface = function (n) {
                return this.each(function () {
                    var i = t(this).data(Mn),
                        o = "object" == typeof n && n;
                    if ((i || !/dispose|hide/.test(n)) && (i || (i = new e(this, o), t(this).data(Mn, i)), "string" == typeof n)) {
                        if ("undefined" == typeof i[n]) throw new TypeError('No method named "' + n + '"');
                        i[n]()
                    }
                })
            }, o(e, null, [{
                key: "VERSION",
                get: function () {
                    return Bn
                }
            }, {
                key: "Default",
                get: function () {
                    return Gn
                }
            }, {
                key: "NAME",
                get: function () {
                    return Hn
                }
            }, {
                key: "DATA_KEY",
                get: function () {
                    return Mn
                }
            }, {
                key: "Event",
                get: function () {
                    return ei
                }
            }, {
                key: "EVENT_KEY",
                get: function () {
                    return Un
                }
            }, {
                key: "DefaultType",
                get: function () {
                    return zn
                }
            }]), e
        }();
    t.fn[Hn] = ci._jQueryInterface, t.fn[Hn].Constructor = ci, t.fn[Hn].noConflict = function () {
        return t.fn[Hn] = Wn, ci._jQueryInterface
    };
    var hi = "popover",
        ui = "4.5.2",
        di = "bs.popover",
        fi = "." + di,
        gi = t.fn[hi],
        mi = "bs-popover",
        pi = new RegExp("(^|\\s)" + mi + "\\S+", "g"),
        _i = s({}, ci.Default, {
            placement: "right",
            trigger: "click",
            content: "",
            template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>'
        }),
        vi = s({}, ci.DefaultType, {
            content: "(string|element|function)"
        }),
        yi = "fade",
        bi = "show",
        wi = ".popover-header",
        Ti = ".popover-body",
        Ei = {
            HIDE: "hide" + fi,
            HIDDEN: "hidden" + fi,
            SHOW: "show" + fi,
            SHOWN: "shown" + fi,
            INSERTED: "inserted" + fi,
            CLICK: "click" + fi,
            FOCUSIN: "focusin" + fi,
            FOCUSOUT: "focusout" + fi,
            MOUSEENTER: "mouseenter" + fi,
            MOUSELEAVE: "mouseleave" + fi
        },
        Ci = function (e) {
            function n() {
                return e.apply(this, arguments) || this
            }
            r(n, e);
            var i = n.prototype;
            return i.isWithContent = function () {
                return this.getTitle() || this._getContent()
            }, i.addAttachmentClass = function (e) {
                t(this.getTipElement()).addClass(mi + "-" + e)
            }, i.getTipElement = function () {
                return this.tip = this.tip || t(this.config.template)[0], this.tip
            }, i.setContent = function () {
                var e = t(this.getTipElement());
                this.setElementContent(e.find(wi), this.getTitle());
                var n = this._getContent();
                "function" == typeof n && (n = n.call(this.element)), this.setElementContent(e.find(Ti), n), e.removeClass(yi + " " + bi)
            }, i._getContent = function () {
                return this.element.getAttribute("data-content") || this.config.content
            }, i._cleanTipClass = function () {
                var e = t(this.getTipElement()),
                    n = e.attr("class").match(pi);
                null !== n && n.length > 0 && e.removeClass(n.join(""))
            }, n._jQueryInterface = function (e) {
                return this.each(function () {
                    var i = t(this).data(di),
                        o = "object" == typeof e ? e : null;
                    if ((i || !/dispose|hide/.test(e)) && (i || (i = new n(this, o), t(this).data(di, i)), "string" == typeof e)) {
                        if ("undefined" == typeof i[e]) throw new TypeError('No method named "' + e + '"');
                        i[e]()
                    }
                })
            }, o(n, null, [{
                key: "VERSION",
                get: function () {
                    return ui
                }
            }, {
                key: "Default",
                get: function () {
                    return _i
                }
            }, {
                key: "NAME",
                get: function () {
                    return hi
                }
            }, {
                key: "DATA_KEY",
                get: function () {
                    return di
                }
            }, {
                key: "Event",
                get: function () {
                    return Ei
                }
            }, {
                key: "EVENT_KEY",
                get: function () {
                    return fi
                }
            }, {
                key: "DefaultType",
                get: function () {
                    return vi
                }
            }]), n
        }(ci);
    t.fn[hi] = Ci._jQueryInterface, t.fn[hi].Constructor = Ci, t.fn[hi].noConflict = function () {
        return t.fn[hi] = gi, Ci._jQueryInterface
    };
    var Si = "scrollspy",
        ki = "4.5.2",
        Di = "bs.scrollspy",
        Ni = "." + Di,
        $i = ".data-api",
        Ai = t.fn[Si],
        Ii = {
            offset: 10,
            method: "auto",
            target: ""
        },
        ji = {
            offset: "number",
            method: "string",
            target: "(string|element)"
        },
        Oi = "activate" + Ni,
        xi = "scroll" + Ni,
        Pi = "load" + Ni + $i,
        Ri = "dropdown-item",
        Li = "active",
        Fi = '[data-spy="scroll"]',
        qi = ".nav, .list-group",
        Qi = ".nav-link",
        Hi = ".nav-item",
        Bi = ".list-group-item",
        Mi = ".dropdown",
        Ui = ".dropdown-item",
        Wi = ".dropdown-toggle",
        Vi = "offset",
        Ki = "position",
        Xi = function () {
            function e(e, n) {
                var i = this;
                this._element = e, this._scrollElement = "BODY" === e.tagName ? window : e, this._config = this._getConfig(n), this._selector = this._config.target + " " + Qi + "," + (this._config.target + " " + Bi + ",") + (this._config.target + " " + Ui), this._offsets = [], this._targets = [], this._activeTarget = null, this._scrollHeight = 0, t(this._scrollElement).on(xi, function (e) {
                    return i._process(e)
                }), this.refresh(), this._process()
            }
            var n = e.prototype;
            return n.refresh = function () {
                var e = this,
                    n = this._scrollElement === this._scrollElement.window ? Vi : Ki,
                    i = "auto" === this._config.method ? n : this._config.method,
                    o = i === Ki ? this._getScrollTop() : 0;
                this._offsets = [], this._targets = [], this._scrollHeight = this._getScrollHeight();
                var s = [].slice.call(document.querySelectorAll(this._selector));
                s.map(function (e) {
                    var n, s = p.getSelectorFromElement(e);
                    if (s && (n = document.querySelector(s)), n) {
                        var r = n.getBoundingClientRect();
                        if (r.width || r.height) return [t(n)[i]().top + o, s]
                    }
                    return null
                }).filter(function (e) {
                    return e
                }).sort(function (e, t) {
                    return e[0] - t[0]
                }).forEach(function (t) {
                    e._offsets.push(t[0]), e._targets.push(t[1])
                })
            }, n.dispose = function () {
                t.removeData(this._element, Di), t(this._scrollElement).off(Ni), this._element = null, this._scrollElement = null, this._config = null, this._selector = null, this._offsets = null, this._targets = null, this._activeTarget = null, this._scrollHeight = null
            }, n._getConfig = function (e) {
                if (e = s({}, Ii, "object" == typeof e && e ? e : {}), "string" != typeof e.target && p.isElement(e.target)) {
                    var n = t(e.target).attr("id");
                    n || (n = p.getUID(Si), t(e.target).attr("id", n)), e.target = "#" + n
                }
                return p.typeCheckConfig(Si, e, ji), e
            }, n._getScrollTop = function () {
                return this._scrollElement === window ? this._scrollElement.pageYOffset : this._scrollElement.scrollTop
            }, n._getScrollHeight = function () {
                return this._scrollElement.scrollHeight || Math.max(document.body.scrollHeight, document.documentElement.scrollHeight)
            }, n._getOffsetHeight = function () {
                return this._scrollElement === window ? window.innerHeight : this._scrollElement.getBoundingClientRect().height
            }, n._process = function () {
                var e = this._getScrollTop() + this._config.offset,
                    t = this._getScrollHeight(),
                    n = this._config.offset + t - this._getOffsetHeight();
                if (this._scrollHeight !== t && this.refresh(), e >= n) {
                    var i = this._targets[this._targets.length - 1];
                    return void(this._activeTarget !== i && this._activate(i))
                }
                if (this._activeTarget && e < this._offsets[0] && this._offsets[0] > 0) return this._activeTarget = null, void this._clear();
                for (var o = this._offsets.length; o--;) {
                    var s = this._activeTarget !== this._targets[o] && e >= this._offsets[o] && ("undefined" == typeof this._offsets[o + 1] || e < this._offsets[o + 1]);
                    s && this._activate(this._targets[o])
                }
            }, n._activate = function (e) {
                this._activeTarget = e, this._clear();
                var n = this._selector.split(",").map(function (t) {
                        return t + '[data-target="' + e + '"],' + t + '[href="' + e + '"]'
                    }),
                    i = t([].slice.call(document.querySelectorAll(n.join(","))));
                i.hasClass(Ri) ? (i.closest(Mi).find(Wi).addClass(Li), i.addClass(Li)) : (i.addClass(Li), i.parents(qi).prev(Qi + ", " + Bi).addClass(Li), i.parents(qi).prev(Hi).children(Qi).addClass(Li)), t(this._scrollElement).trigger(Oi, {
                    relatedTarget: e
                })
            }, n._clear = function () {
                [].slice.call(document.querySelectorAll(this._selector)).filter(function (e) {
                    return e.classList.contains(Li)
                }).forEach(function (e) {
                    return e.classList.remove(Li)
                })
            }, e._jQueryInterface = function (n) {
                return this.each(function () {
                    var i = t(this).data(Di),
                        o = "object" == typeof n && n;
                    if (i || (i = new e(this, o), t(this).data(Di, i)), "string" == typeof n) {
                        if ("undefined" == typeof i[n]) throw new TypeError('No method named "' + n + '"');
                        i[n]()
                    }
                })
            }, o(e, null, [{
                key: "VERSION",
                get: function () {
                    return ki
                }
            }, {
                key: "Default",
                get: function () {
                    return Ii
                }
            }]), e
        }();
    t(window).on(Pi, function () {
        for (var e = [].slice.call(document.querySelectorAll(Fi)), n = e.length, i = n; i--;) {
            var o = t(e[i]);
            Xi._jQueryInterface.call(o, o.data())
        }
    }), t.fn[Si] = Xi._jQueryInterface, t.fn[Si].Constructor = Xi, t.fn[Si].noConflict = function () {
        return t.fn[Si] = Ai, Xi._jQueryInterface
    };
    var zi = "tab",
        Yi = "4.5.2",
        Gi = "bs.tab",
        Ji = "." + Gi,
        Zi = ".data-api",
        eo = t.fn[zi],
        to = "hide" + Ji,
        no = "hidden" + Ji,
        io = "show" + Ji,
        oo = "shown" + Ji,
        so = "click" + Ji + Zi,
        ro = "dropdown-menu",
        ao = "active",
        lo = "disabled",
        co = "fade",
        ho = "show",
        uo = ".dropdown",
        fo = ".nav, .list-group",
        go = ".active",
        mo = "> li > .active",
        po = '[data-toggle="tab"], [data-toggle="pill"], [data-toggle="list"]',
        _o = ".dropdown-toggle",
        vo = "> .dropdown-menu .active",
        yo = function () {
            function e(e) {
                this._element = e
            }
            var n = e.prototype;
            return n.show = function () {
                var e = this;
                if (!(this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE && t(this._element).hasClass(ao) || t(this._element).hasClass(lo))) {
                    var n, i, o = t(this._element).closest(fo)[0],
                        s = p.getSelectorFromElement(this._element);
                    if (o) {
                        var r = "UL" === o.nodeName || "OL" === o.nodeName ? mo : go;
                        i = t.makeArray(t(o).find(r)), i = i[i.length - 1]
                    }
                    var a = t.Event(to, {
                            relatedTarget: this._element
                        }),
                        l = t.Event(io, {
                            relatedTarget: i
                        });
                    if (i && t(i).trigger(a), t(this._element).trigger(l), !l.isDefaultPrevented() && !a.isDefaultPrevented()) {
                        s && (n = document.querySelector(s)), this._activate(this._element, o);
                        var c = function () {
                            var n = t.Event(no, {
                                    relatedTarget: e._element
                                }),
                                o = t.Event(oo, {
                                    relatedTarget: i
                                });
                            t(i).trigger(n), t(e._element).trigger(o)
                        };
                        n ? this._activate(n, n.parentNode, c) : c()
                    }
                }
            }, n.dispose = function () {
                t.removeData(this._element, Gi), this._element = null
            }, n._activate = function (e, n, i) {
                var o = this,
                    s = !n || "UL" !== n.nodeName && "OL" !== n.nodeName ? t(n).children(go) : t(n).find(mo),
                    r = s[0],
                    a = i && r && t(r).hasClass(co),
                    l = function () {
                        return o._transitionComplete(e, r, i)
                    };
                if (r && a) {
                    var c = p.getTransitionDurationFromElement(r);
                    t(r).removeClass(ho).one(p.TRANSITION_END, l).emulateTransitionEnd(c)
                } else l()
            }, n._transitionComplete = function (e, n, i) {
                if (n) {
                    t(n).removeClass(ao);
                    var o = t(n.parentNode).find(vo)[0];
                    o && t(o).removeClass(ao), "tab" === n.getAttribute("role") && n.setAttribute("aria-selected", !1)
                }
                if (t(e).addClass(ao), "tab" === e.getAttribute("role") && e.setAttribute("aria-selected", !0), p.reflow(e), e.classList.contains(co) && e.classList.add(ho), e.parentNode && t(e.parentNode).hasClass(ro)) {
                    var s = t(e).closest(uo)[0];
                    if (s) {
                        var r = [].slice.call(s.querySelectorAll(_o));
                        t(r).addClass(ao)
                    }
                    e.setAttribute("aria-expanded", !0)
                }
                i && i()
            }, e._jQueryInterface = function (n) {
                return this.each(function () {
                    var i = t(this),
                        o = i.data(Gi);
                    if (o || (o = new e(this), i.data(Gi, o)), "string" == typeof n) {
                        if ("undefined" == typeof o[n]) throw new TypeError('No method named "' + n + '"');
                        o[n]()
                    }
                })
            }, o(e, null, [{
                key: "VERSION",
                get: function () {
                    return Yi
                }
            }]), e
        }();
    t(document).on(so, po, function (e) {
        e.preventDefault(), yo._jQueryInterface.call(t(this), "show")
    }), t.fn[zi] = yo._jQueryInterface, t.fn[zi].Constructor = yo, t.fn[zi].noConflict = function () {
        return t.fn[zi] = eo, yo._jQueryInterface
    };
    var bo = "toast",
        wo = "4.5.2",
        To = "bs.toast",
        Eo = "." + To,
        Co = t.fn[bo],
        So = "click.dismiss" + Eo,
        ko = "hide" + Eo,
        Do = "hidden" + Eo,
        No = "show" + Eo,
        $o = "shown" + Eo,
        Ao = "fade",
        Io = "hide",
        jo = "show",
        Oo = "showing",
        xo = {
            animation: "boolean",
            autohide: "boolean",
            delay: "number"
        },
        Po = {
            animation: !0,
            autohide: !0,
            delay: 500
        },
        Ro = '[data-dismiss="toast"]',
        Lo = function () {
            function e(e, t) {
                this._element = e, this._config = this._getConfig(t), this._timeout = null, this._setListeners()
            }
            var n = e.prototype;
            return n.show = function () {
                var e = this,
                    n = t.Event(No);
                if (t(this._element).trigger(n), !n.isDefaultPrevented()) {
                    this._clearTimeout(), this._config.animation && this._element.classList.add(Ao);
                    var i = function () {
                        e._element.classList.remove(Oo), e._element.classList.add(jo), t(e._element).trigger($o), e._config.autohide && (e._timeout = setTimeout(function () {
                            e.hide()
                        }, e._config.delay))
                    };
                    if (this._element.classList.remove(Io), p.reflow(this._element), this._element.classList.add(Oo), this._config.animation) {
                        var o = p.getTransitionDurationFromElement(this._element);
                        t(this._element).one(p.TRANSITION_END, i).emulateTransitionEnd(o)
                    } else i()
                }
            }, n.hide = function () {
                if (this._element.classList.contains(jo)) {
                    var e = t.Event(ko);
                    t(this._element).trigger(e), e.isDefaultPrevented() || this._close()
                }
            }, n.dispose = function () {
                this._clearTimeout(), this._element.classList.contains(jo) && this._element.classList.remove(jo), t(this._element).off(So), t.removeData(this._element, To), this._element = null, this._config = null
            }, n._getConfig = function (e) {
                return e = s({}, Po, t(this._element).data(), "object" == typeof e && e ? e : {}), p.typeCheckConfig(bo, e, this.constructor.DefaultType), e
            }, n._setListeners = function () {
                var e = this;
                t(this._element).on(So, Ro, function () {
                    return e.hide()
                })
            }, n._close = function () {
                var e = this,
                    n = function () {
                        e._element.classList.add(Io), t(e._element).trigger(Do)
                    };
                if (this._element.classList.remove(jo), this._config.animation) {
                    var i = p.getTransitionDurationFromElement(this._element);
                    t(this._element).one(p.TRANSITION_END, n).emulateTransitionEnd(i)
                } else n()
            }, n._clearTimeout = function () {
                clearTimeout(this._timeout), this._timeout = null
            }, e._jQueryInterface = function (n) {
                return this.each(function () {
                    var i = t(this),
                        o = i.data(To),
                        s = "object" == typeof n && n;
                    if (o || (o = new e(this, s), i.data(To, o)), "string" == typeof n) {
                        if ("undefined" == typeof o[n]) throw new TypeError('No method named "' + n + '"');
                        o[n](this)
                    }
                })
            }, o(e, null, [{
                key: "VERSION",
                get: function () {
                    return wo
                }
            }, {
                key: "DefaultType",
                get: function () {
                    return xo
                }
            }, {
                key: "Default",
                get: function () {
                    return Po
                }
            }]), e
        }();
    t.fn[bo] = Lo._jQueryInterface, t.fn[bo].Constructor = Lo, t.fn[bo].noConflict = function () {
        return t.fn[bo] = Co, Lo._jQueryInterface
    }, e.Alert = A, e.Button = Y, e.Carousel = Me, e.Collapse = ut, e.Dropdown = Zt, e.Modal = Pn, e.Popover = Ci, e.Scrollspy = Xi, e.Tab = yo, e.Toast = Lo, e.Tooltip = ci, e.Util = p, Object.defineProperty(e, "__esModule", {
        value: !0
    })
});
var top_nav_menu = {
        init: function () {
            top_nav_menu.hover_dropdown()
        },
        hover_dropdown: function () {
            $(".dropdown").hover(function () {
                $(this).find(".dropdown-menu").stop(!0, !0).delay(100).fadeIn(300)
            }, function () {
                $(this).find(".dropdown-menu").stop(!0, !0).delay(100).fadeOut(300)
            }), $(".dropdown > a").click(function () {
                location.href = this.href
            })
        }
    },
    sticky_nav = {
        init: function () {
            if (window.matchMedia("(max-width: 575px)").matches) {
                var e = 60;
                $(window).scroll(function (t) {
                    var n = $(this).scrollTop();
                    n > e ? ($(".top-header").addClass("sticky"), $(".primary-nav").removeClass("sticky")) : ($(".top-header").removeClass("sticky"), $(".top-header").addClass("none-sticky"), $(".primary-nav").addClass("sticky")), 0 == n && ($(".top-header").addClass("sticky"), $(".primary-nav").removeClass("sticky")), e = n
                })
            }
        }
    },
    about_nav_menu = {
        init: function () {
            $(".menu-toggler").on("click", function () {
                return $(this).toggleClass("show"), $(".about-nav").toggleClass("show"), !1
            })
        }
    },
    menu_mobile = {
        init: function () {
            $(".mobile-menu-toggler").on("click", function () {
                $(this).toggleClass("show"), $("#primary-nav").toggleClass("show"), $(".modal-overlay").toggleClass("show"), $("body").toggleClass("display-scroll")
            })
        }
    },
    hero_slide = {
        init: function () { 
            var e = $(".hero-slide .list-slider"),
                t = $(".hero-slide .list-slider .slide-item").length;
            e.length > 0 && t > 1 && e.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: !0,
                autoplaySpeed: 5000,
                dots: !0,
                arrows: !0,
                lazyLoad: "ondemand",
                responsive: [{
                    breakpoint: 575,
                    settings: {
                        arrows: !1
                    }
                }]
            })
        }
    },
    home_product = {
        init: function () {
            var e = $(".home-product .list-product-slide"),
                t = $(".home-product .list-product-slide .product").length;
            e.length > 0 && t > 3 && e.slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                dots: !1,
                arrows: !0,
                responsive: [{
                    breakpoint: 768,
                    settings: {
                        autoplay: !0,
                        autoplaySpeed: 5000,
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        arrows: !0
                    }
                }]
            })
        }
    },
    home_brand = {
        init: function () {
            var e = $(".list-brand"),
                t = $(".list-brand .col-md-2").length;
            e.length > 0 && t > 4 && e.slick({
                slidesToShow: 6,
                slidesToScroll: 1,
                dots: !1,
                arrows: !0,
                infinite: !0,
                autoplay: !0,
                autoplaySpeed: 5000,
                responsive: [{
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }]
            })
        }
    },
    product_viewed = {
        init: function () {
            var e = $(".list-product-viewed"),
                t = $(".list-product-viewed .product").length;
            e.length > 0 && t > 4 && e.slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                dots: !1,
                arrows: !0,
                responsive: [{
                    breakpoint: 576,
                    settings: {
                        autoplay: !0,
                        autoplaySpeed: 5000,
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        arrows: !1,
                        dots: !1
                    }
                }]
            })
        }
    },
    product_bestsale = {
        init: function () {
            var e = $(".list-product-grid"),
                t = $(".list-product-grid .product").length;
            e.length > 0 && t > 4 && e.slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                dots: !1,
                arrows: !0,
                responsive: [{
                    breakpoint: 576,
                    settings: {
                        autoplay: !0,
                        autoplaySpeed: 5000,
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        arrows: !1,
                        dots: !0
                    }
                }]
            })
        }
    },
    feedback_customer = {
        init: function () {
            var e = $(".home-feedback-slide"),
                t = $(".home-feedback-slide .list-feedback").length;
            e.length > 0 && t > 1 && e.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: !1,
                arrows: !0,
                responsive: [{
                    breakpoint: 576,
                    settings: {
                        autoplay: !0,
                        autoplaySpeed: 5000,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: !0,
                        dots: !1
                    }
                }]
            })
        }
    },
    common_settings = {
        init: function () {
            $(".menu-cat .menu-header").click(function () {
                $(this).toggleClass("show"), $(".menu-cat .menu-body").toggleClass("show")
            }), $(".icon-toggler").click(function () {
                $(".page-header .col-menu").toggleClass("show")
            }), $(".btn-to-top").on("click", function (e) {
                e.preventDefault(), $("html,body").animate({
                    scrollTop: 0
                }, 700)
            }), $(window).scroll(function (e) {
                var t = $(this).scrollTop();
                t >= 300 ? $(".action-desktop").addClass("show") : $(".action-desktop").removeClass("show")
            }), $(".entry iframe").addClass("embed-responsive-item"), $(".entry iframe").wrap("<div class='embed-responsive embed-responsive-16by9'></div>");
            var e = $('.comment-form [name="comment"]');
            e.length > 0 && e.focus(function () {
                $(".comment-form .comment-form-author").addClass("show"), $(".comment-form .comment-form-email").addClass("show")
            }), $(".product-type-cat .new").click(function () {
                var e = window.location.origin,
                    t = e + "/gay-golf";
                $(location).attr("href", t)
            }), $(".product-type-cat .like-new").click(function () {
                var e = window.location.origin,
                    t = e + "/gay-golf-cu";
                $(location).attr("href", t)
            });
            var t = $(".primary-nav .bar-button"),
                n = $(window).width();
            t.length && (n > 768 && $("body").hasClass("home") ? ($(window).scroll(function () {
                var e = $(window).scrollTop();
                e > 550 ? t.addClass("is-click") : t.removeClass("is-click")
            }), $(".is-dropdown").on("click", ".is-click", function () {
                $(this).toggleClass("show"), $(this).siblings(".menu-side-slide").toggleClass("show")
            })) : t.click(function () {
                $(this).toggleClass("show"), $(this).siblings(".menu-side-slide").toggleClass("show")
            })), jQuery(document).click(function (e) {
                jQuery(e.target).closest(".menu-side-slide, .primary-nav .bar-button").length || jQuery(".menu-side-slide, .primary-nav .bar-button").removeClass("show")
            }), $(".btn-register, .btn-booking-golf").click(function (e) {
                e.preventDefault();
                $("#registermodal").modal("show")
            })
        }
    },
    google_form_contact = {
        init: function () {
            var e = $(".contact-form");
            e.length > 0 && e.on("submit", function () {
                var e = $(this);
                return google_form_contact.send_contact_to_google(e), !1
            })
        },
        send_contact_to_google: function (e) {
            $('body').loading('toggle');

            var t = $(e).find('[name="name"]').val(),
                n = $(e).find('[name="phone"]').val(),
                i = $(e).find('[name="content"]').val(),
                o = $(e).find('[name="email"]').val(),
                s = window.location.href,
                r = document.referrer;
            "" !== t && "" !== n ? $.ajax({
                url: $(e).attr('action'),
                data: e.serialize(),
                type: "POST",
                dataType: "xml",
                statusCode: {
                    0: function () {
                        $(e).closest("form").find("[type=text], [type=email]").val(""), $(e).find("button").attr("disabled", "disabled"), $("#registermodal").modal("hide"), setTimeout(function () {
                            $("#modalsucess").modal("show")
                        }, 2e3), setTimeout(function () {
                            $("#modalsucess").modal("hide"), location.reload()
                        }, 5e3);
                    },
                    200: function () {
                        $(e).closest("form").find("[type=text], [type=email]").val(""), $(e).find("button").attr("disabled", "disabled"), $("#registermodal").modal("hide"), setTimeout(function () {
                            $("#modalsucess").modal("show")
                        }, 2e3), setTimeout(function () {
                            $("#modalsucess").modal("hide"), location.reload()
                        }, 5e3);
                    }
                }
            }) : alert("Kiểm tra lại các thông vừa nhập")
        }
    },
    google_form_register = {
        init: function () {
            var e = $(".register-form");
            e.length > 0 && e.on("submit", function () {
                var e = $(this);
                return google_form_register.send_register_to_google(e), !1
            })
        },
        send_register_to_google: function (e) {
            $('body').loading('toggle');

            var t = $(e).find('[name="name"]').val(),
                n = $(e).find('[name="phone"]').val(),
                r = window.location.href,
                a = document.referrer;

            "" !== t && "" !== n ? $.ajax({
                url: $(e).attr('action'),
                data: e.serialize(),
                type: "POST",
                dataType: "xml",
                statusCode: {
                    0: function () {
                        $(e).closest("form").find("[type=text], [type=email]").val(""), $(e).find("button").attr("disabled", "disabled"), $("#registermodal").modal("hide"), setTimeout(function () {
                            $("#modalsucess").modal("show")
                        }, 2e3), setTimeout(function () {
                            $("#modalsucess").modal("hide"), location.reload()
                        }, 5e3);
                    },
                    200: function () {
                        $(e).closest("form").find("[type=text], [type=email]").val(""), $(e).find("button").attr("disabled", "disabled"), $("#registermodal").modal("hide"), setTimeout(function () {
                            $("#modalsucess").modal("show")
                        }, 2e3), setTimeout(function () {
                            $("#modalsucess").modal("hide"), location.reload()
                        }, 5e3);
                    }
                }
            }) : alert("Kiểm tra lại các thông vừa nhập");
        }
    },
    testinomial = {
        init: function () {
            var e = $(".home-testinomial .list-testinomial");
            e.length > 0 && e.slick({
                slidesToShow: 2,
                slidesToScroll: 2,
                dots: !0,
                arrows: !1,
                responsive: [{
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: !1,
                        dots: !0
                    }
                }]
            })
        }
    },
    brand = {
        init: function () {
            var e = $(".home-brand .list-brand"),
                t = $(".home-brand .list-brand .col").length;
            e.length > 0 && t > 4 && e.slick({
                slidesToShow: 5,
                slidesToScroll: 1,
                dots: !1,
                arrows: !1,
                infinite: !1,
                responsive: [{
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        arrows: !1,
                        dots: !0
                    }
                }]
            })
        }
    },
    brand_archive = {
        init: function () {
            var e = $(".list-brand-archive"),
                t = $(".list-brand-archive .col").length;
            e.length > 0 && t > 4 && e.slick({
                slidesToShow: 5,
                slidesToScroll: 1,
                dots: !1,
                arrows: !0,
                infinite: !0,
                autoplay: !0,
                autoplaySpeed: 5000,
                responsive: [{
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        arrows: !1,
                        dots: !0
                    }
                }]
            })
        }
    },
    partner = {
        init: function () {
            var e = $(".home-partner .list-brand");
            e.length > 0 && e.slick({
                slidesToShow: 5,
                slidesToScroll: 5,
                dots: !0,
                arrows: !0,
                responsive: [{
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        arrows: !1,
                        dots: !1
                    }
                }]
            })
        }
    },
    customer = {
        init: function () {
            var e = $(".list-customers"),
                t = $(".list-customers .item-customer");
            t.length > 2 && e.length && e.slick({
                slidesToShow: 2,
                slidesToScroll: 2,
                dots: !0,
                arrows: !1,
                responsive: [{
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: !1,
                        dots: !1,
                        centerMode: !0,
                        centerPadding: "30px"
                    }
                }]
            })
        }
    },
    product_suggest = {
        init: function () {
            var e = $(".list-product-suggest"),
                t = e.children().length;
            e.length > 0 && t > 4 && e.slick({
                slidesToShow: 6,
                slidesToScroll: 3,
                dots: !1,
                arrows: !0,
                responsive: [{
                    breakpoint: 576,
                    settings: {
                        autoplay: !0,
                        autoplaySpeed: 5000,
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        centerMode: !0,
                        centerPadding: "90px",
                        arrows: !1,
                        dots: !1
                    }
                }, {
                    breakpoint: 415,
                    settings: {
                        autoplay: !0,
                        autoplaySpeed: 5000,
                        slidesToShow: 1,
                        slidesToScroll: 2,
                        centerMode: !0,
                        centerPadding: "90px",
                        arrows: !1,
                        dots: !1
                    }
                }]
            })
        }
    },
    newspaper = {
        init: function () {
            var e = $(".list-newspaper"),
                t = $(".list-newspaper .newspaper").length;
            e.length > 0 && t > 2 && e.slick({
                slidesToShow: 4,
                slidesToScroll: 2,
                autoplay: !0,
                autoplaySpeed: 5000,
                dots: !1,
                arrows: !0,
                responsive: [{
                    breakpoint: 575,
                    settings: {
                        arrows: !1,
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }]
            })
        }
    },
    gallery_popup = {
        init: function () {
            var e = $(".image-link");
            e.length > 0 && e.magnificPopup({
                type: "image",
                gallery: {
                    enabled: !0
                }
            })
        }
    },
    product_fillter_mobile = {
        init: function () {
            $(".product-fillter-mobile").on("click", function () {
                $(this).toggleClass("show"), $(".wrap-fillter").toggleClass("show")
            }), $(document).click(function (e) {
                $(e.target).closest(".product-fillter-mobile, .wrap-fillter").length || $(".wrap-fillter, .product-fillter-mobile").removeClass("show")
            })
        }
    },
    single_product_gallery = {
        init: function () {
            var e = $(".list-product-gallery"),
                t = $(".list-product-thumb");
            e.length > 0 && t.length > 0 && ($(".list-product-gallery").slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: !1,
                dots: !1,
                fade: !0,
                asNavFor: ".list-product-thumb"
            }), $(".list-product-thumb").slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                asNavFor: ".list-product-gallery",
                dots: !1,
                focusOnSelect: !0
            }))
        }
    },
    show_more = {
        init: function () {
            var e = $(".archive-description .more-tag");
            e.parent().nextAll().css("display", "none"), e.click(function () {
                return $(this).hide(), e.parent().nextAll().css("display", "block"), !1
            })
        }
    },
    action_bar = {
        init: function () {
            $(".action-bar .call a").click(function () {
                return $(this).toggleClass("active"), $(".action-bar .list-hotline").toggleClass("show"), $(".droplet").toggleClass("show"), !1
            }), $(".droplet").click(function () {
                $(this).toggleClass("show"), $(".action-bar .list-hotline").removeClass("show"), $(".action-bar .call a").removeClass("active")
            })
        }
    },
    google_form = {
        init: function () {
            var e = $(".fitting-form");
            e.length > 0 && e.on("submit", function () {
                var e = $(this);
                return google_form.send_fitting_to_google(e), !1
            })
        },
        send_fitting_to_google: function (e) {
            var t = $(e).find('[name="fullname"]').val(),
                n = $(e).find('[name="numberphone"]').val(),
                i = "Fiiting theo yêu cầu - " + $(e).find('[name="content"]').val(),
                o = window.location.href,
                s = document.referrer,
                r = '<div class="alert alert-success mt-2 message-text text-center" role="alert">';
            r += '<p class="text-center">Gửi thành công! Chúng tôi sẽ sớm liên hệ với bạn.</p>', r += "</div>", "" !== t && "" !== n ? $.ajax({
                url: "https://docs.google.com/forms/u/0/d/e/1FAIpQLSfq3qC3-iFX6KGaLsMGSI4tRyn3L0UcV2anR-fd7F7VPui0Uw/formResponse",
                data: {
                    "entry.1761257764": t,
                    "entry.450145171": n,
                    "entry.916647566": i,
                    "entry.1772138398": o,
                    "entry.410446584": s
                },
                type: "POST",
                dataType: "xml",
                statusCode: {
                    0: function () {
                        $(e).next(".result-form").append(r), $(e).closest("form").find("[type=text], [type=email]").val(""), $(e).find("button").attr("disabled", "disabled"), setTimeout(function () {
                            $(e).next(".result-form").empty()
                        }, 3e3), setTimeout(function () {
                            $("#modal-fitting").modal("hide")
                        }, 5e3)
                    },
                    200: function () {
                        $(e).next(".result-form").append(r), $(e).closest("form").find("[type=text], , [type=email]").val(""), $(e).find("button").attr("disabled", "disabled"), setTimeout(function () {
                            $(e).next(".result-form").empty()
                        }, 3e3), setTimeout(function () {
                            $("#modal-fitting").modal("hide")
                        }, 5e3)
                    }
                }
            }) : alert("Kiểm tra lại các thông vừa nhập")
        }
    },
    slide_video = {
        init: function () {
            var e = $(".home-video .list-video-slide"),
                t = $(".home-video .list-video-slide .list-video-item").length;
            e.length > 0 && t >= 3 && e.slick({
                slidesToShow: 3,
                dots: !1,
                slidesToScroll: 1,
                autoplay: !0,
                autoplaySpeed: 5000,
                speed: 500,
                arrows: !0,
                mobileFirst: !1,
                responsive: [{
                    breakpoint: 1024,
                    settings: "unslick"
                }, {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: !1,
                        arrows: !1,
                        dots: !0
                    }
                }]
            })
        }
    },
    slide_banner_product = {
        init: function () {
            var e = $(".slide-banner-product"),
                t = $(".slide-banner-product .slide-banner-item").length;
            e.length > 0 && t > 0 && e.slick({
                dots: !1,
                slidesToScroll: 1,
                autoplay: !0,
                autoplaySpeed: 5000,
                centerMode: !0,
                centerPadding: "30px",
                speed: 500,
                arrows: !1,
                mobileFirst: !0,
                responsive: [{
                    breakpoint: 1024,
                    settings: "unslick"
                }, {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: !0,
                        arrows: !1,
                        dots: !1,
                        infinite: !0,
                        variableWidth: !0,
                        centerPadding: "30px"
                    }
                }]
            })
        }
    };
jQuery(document).ready(function () {
    top_nav_menu.init(), about_nav_menu.init(), menu_mobile.init(), common_settings.init(), google_form.init(), google_form_contact.init(), hero_slide.init(), home_product.init(), home_brand.init(), testinomial.init(), gallery_popup.init(), partner.init(), customer.init(), brand.init(), newspaper.init(), brand_archive.init(), product_viewed.init(), product_fillter_mobile.init(), single_product_gallery.init(), show_more.init(), action_bar.init(), product_suggest.init(), product_bestsale.init(), feedback_customer.init(), slide_video.init(), slide_banner_product.init(), google_form_register.init(), $(".list-service").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: !0,
        arrows: !0,
        asNavFor: ".list-title"
    }), $(".list-title").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: ".list-service",
        dots: !1,
        arrows: !1,
        centerMode: !0,
        focusOnSelect: !0,
        responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: !0
            }
        }]
    })
});
